<div
    class="grid-filters-bar-wrapper"
    [class.grid-filters-mobile-dialog-opened]="isMobileFiltersDialogOpen"
    [class.grid-filters-tags-displayed]="selectedFiltersSignal().length > 0"
    #filterBar>
    @if (isMobile || isServer) {

    <div class="mobile-only mobile-bar-filter-wrapper">
        <h-grid-filters-mobile-dialog
            [selectedFilters]="selectedFiltersSignal().length"
            (isMobileFiltersDialogOpen)="onIsMobileFiltersDialogChange($event)">
        </h-grid-filters-mobile-dialog>
    </div>

    <div class="mobile-only mobile-bar-display-wrapper">
        <h-grid-display-mode [displayMode]="displayMode" (changeDisplayMode)="onChangeDisplayMode($event)">
        </h-grid-display-mode>
    </div>

    <div class="mobile-only mobile-bar-select-wrapper">
        <h-grid-sort [selectedValue]="selectedSort" (sortChanged)="onSortChanged($event)"></h-grid-sort>
    </div>

    } @if (!isMobile || isServer) {
    <div class="desktop-only desktop-bar-wrapper">
        <h-grid-filters-responsive-menu [selectedValue]="selectedSort" [mobileMode]="false">
        </h-grid-filters-responsive-menu>
        <h-grid-filters-tags></h-grid-filters-tags>
    </div>
    }
</div>

<!-- empty space to fill the absence in the dom of the filter bar when fixed -->
<div class="placeholder" #emptySpace>
    <div class="filter-bar-placeholder"></div>
    <h-grid-filters-tags class="tag-bar-placeholder desktop-only"> </h-grid-filters-tags>
</div>
